"use strict";
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnswerDisplayString = void 0;
const AnswerStatus_1 = require("evolution-common/lib/services/baseObjects/attributeTypes/AnswerStatus");
/**
 * Display an answer for a reviewer: the value when one was given, otherwise the
 * translated reason there is none. A plain number or boolean is the answered
 * value itself.
 *
 * @param answer The answer to display, wrapped or as the value
 * @param t The translation function
 * @return The value that was answered, the translated reason there is none, or
 * `?` when no answer was recorded
 */
const getAnswerDisplayString = (answer, t) => {
    const wrapped = (0, AnswerStatus_1.isAnswerStatus)(answer) ? answer : (0, AnswerStatus_1.toAnswerStatus)(answer);
    return wrapped === undefined || wrapped.status === 'answered'
        ? (0, AnswerStatus_1.answerToString)(wrapped)
        : t(`interviewStats.answerStatus.${wrapped.status}`);
};
exports.getAnswerDisplayString = getAnswerDisplayString;
//# sourceMappingURL=answerStatusHelper.js.map